import { createContext } from "react";
import { ConsumerTokens } from "@type/tokens";
import { defaultConsumerTokens } from "@constants/tokens";

export const EnigmaContext = createContext<ConsumerTokens>(
    defaultConsumerTokens
);
